import React, { Component, Fragment } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import { Col, Row, Card, Table } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import PageTitle from '../../../Layout/AppMain/PageTitle';
import moment from 'moment';
import { GET_PROCESS_DATA, GET_ASSETS_SAVE_LIST, PRINT_CARRIER_LABELS, CLEAR_PROCESS_DATA, DOWNLOAD_CARRIER_DOCUMENT, DOWNLOAD_PACKAGE_DOCUMENT } from '../../../actions/processList'

const mapStateToProps = state => {
    return {
        selectedProcessData: state.processList.selectedProcessData,
        assetsList: state.processList.assetsList,
        requestCarrierLabels: state.processList.requestCarrierLabels,
    }
}

const mapActionsToProps = {
    GET_PROCESS_DATA: (reqId) => GET_PROCESS_DATA(reqId),
    GET_ASSETS_SAVE_LIST: (requestId) => GET_ASSETS_SAVE_LIST(requestId),
    PRINT_CARRIER_LABELS: (payload) => PRINT_CARRIER_LABELS(payload),
    CLEAR_PROCESS_DATA: () => CLEAR_PROCESS_DATA(),
    DOWNLOAD_CARRIER_DOCUMENT: (payload) => DOWNLOAD_CARRIER_DOCUMENT(payload),
    DOWNLOAD_PACKAGE_DOCUMENT: (payload) => DOWNLOAD_PACKAGE_DOCUMENT(payload),
}

class Reports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            requestId: parseInt(this.props.location.state.reqId),
            compLoc: this.props.location.state.compLoc,
            selectTrackNumber: this.props.location.state.compLoc ? this.props.location.state.selectTrackNumber : null, // used when we redirect back to reception page with current data
            receptionType: this.props.location.state.compLoc ? this.props.location.state.receptionType : null, // used when we redirect back to reception page with current data
            selectedDispalyId: null,
            initialLoading: false,
        }
    }

    async componentDidMount() {
        await this.closeLoader(true)
        await this.props.GET_PROCESS_DATA(this.state.requestId);
        if (this.props.selectedProcessData && this.props.selectedProcessData.b2cCustomer) {
            this.props.GET_ASSETS_SAVE_LIST(this.state.requestId)
        }
        await this.closeLoader(false)
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { selectedProcessData } = nextProps;
        if (selectedProcessData && selectedProcessData.displayId) {
            this.setState({ selectedDispalyId: selectedProcessData.displayId })
        }
    }

    closeLoader = (initialLoading) => {
        setTimeout(() => {
            this.setState({
                initialLoading: initialLoading
            })
        }, 50);
    }

    componentWillUnmount() {
        this.props.CLEAR_PROCESS_DATA()
    }

    printRequestLabel = async (requestInfo, type, labelAndShipmentType) => {
        const { requestCarrierLabels,programRequestTypes, selectedProcessData } = this.props
        const { id: requestId } = requestInfo
        const payload = {
            requestId,
            programId: this.props.selectedProcessData.programId,
            labelAndShipmentType: labelAndShipmentType
        }
        this.setState({ isLabelLoading: true })
        const homeCarrierInfoData = await this.props.PRINT_CARRIER_LABELS(payload)
        this.setState({ isLabelLoading: false })
        if (this.props.requestCarrierLabelError) {
            console.log(`print label error occured`, this.props.requestCarrierLabelError);
            this.props.SET_CARRIER_LABEL_ERROR(null)
        }
        const requestTypeInfo = programRequestTypes && selectedProcessData && programRequestTypes.find((requestType) => requestType.requestTypeId === selectedProcessData.requestTypeId)
        if (homeCarrierInfoData.carrierData === null) {
            let filename
            if (type === 'label') {
                filename = homeCarrierInfoData.data.docTypeLabel
            }
            if (type === 'invoice') {
                filename = homeCarrierInfoData.data.docTypeInvoice
            }
            if (type === 'package') {
                if(homeCarrierInfoData.data.docTypePackage) {
                    filename = homeCarrierInfoData.data.docTypePackage
                } else {
                    this.downloadPackageInstructionFile(requestTypeInfo)
                }
            }
            if(filename) {
                await this.props.DOWNLOAD_CARRIER_DOCUMENT({ requestId, filename })
            }
        } else {
            const labelData = requestCarrierLabels[`request_${requestId}`]
            let imgData = ''
            let invoiceData = ''
            let shippingReceipt = ''            
            if (labelData) {
                const packResults = labelData && labelData.ShipmentResults && labelData.ShipmentResults.PackageResults
                if (packResults && packResults.length) {
                    imgData = packResults[0].ShippingLabel && packResults[0].ShippingLabel["GraphicImage"]
                    shippingReceipt = packResults[0].ShippingReceipt && packResults[0].ShippingReceipt["GraphicImage"]  //Html Description
                }
                const invoiceMain = labelData && labelData.ShipmentResults && labelData && labelData.ShipmentResults.Form
                if (invoiceMain) {
                    invoiceData = invoiceMain && invoiceMain.Image && invoiceMain.Image["GraphicImage"]
                }
            }

            switch (type) {
                case 'label':
                    if (imgData) {
                        this.downloadImage(imgData, 'ShippingLabel')
                    }
                    break;
                case 'receipt':
                    if (shippingReceipt) {
                        const linkSource = `data:application/html;base64,${shippingReceipt}`
                        return linkSource
                    }
                    break
                case 'invoice':
                    if (invoiceData) {
                        this.downloadPDF(invoiceData, 'shippingInvoice')
                    }
                    break
                case 'package':
                    if (requestTypeInfo) {
                        this.downloadPackageInstructionFile(requestTypeInfo)
                    }
                    break
                default:
            }
        }
    }

    downloadPackageInstructionFile = async (requestTypeInfo) => {
        const { programId } = this.state  
        let docName = requestTypeInfo && requestTypeInfo.packageInstructionDocument.split('/')[2]
        const payload = {
           requestTypeId: requestTypeInfo.requestTypeId,
           programId,
           docName
        }
        await this.props.DOWNLOAD_PACKAGE_DOCUMENT(payload)
    }

    onClickBack = async () => {
        if (this.state.compLoc) {
            this.props.history.push({
                pathname: '/dashboard/reception',
                state: { selectTrackNumber: this.state.selectTrackNumber, receptionType: this.state.receptionType, prevState: true }
            })
        } else {
            this.props.history.push({
                pathname: '/dashboard/label',
            })
        }

    }

    downloadImage = (image, imageName) => {
        const linkSource = `data:image/png;base64,${image}`;
        const downloadLink = document.createElement("a");
        const fileName = `${imageName}.png`;
        downloadLink.href = linkSource;

        downloadLink.download = fileName;
        downloadLink.click();
    }

    downloadPDF = (pdf, pdfName) => {
        const linkSource = `data:application/pdf;base64,${pdf}`;
        const downloadLink = document.createElement("a");
        const fileName = `${pdfName}.pdf`;
        downloadLink.href = linkSource;

        downloadLink.download = fileName;
        downloadLink.click();
    }

    render() {
        const { selectedProcessData } = this.props
        return (
            <Fragment>
                <CSSTransitionGroup
                    component="div"
                    transitionName="TabsAnimation"
                    transitionAppear={true}
                    transitionAppearTimeout={0}
                    transitionEnter={false}
                    transitionLeave={false}>
                    <div>
                        <PageTitle heading="Labels Details" subheading="Here you will see all Labels Details" icon="pe-7s-ticket icon-gradient bg-ripe-malin" />
                        <Card style={{ marginTop: '20px', padding: "20px" }}>
                            {!selectedProcessData || this.state.initialLoading ?
                                (<div className="tbl_row" style={{ display: 'flex', justifyContent: 'center'}}><span className="text-center font-weight-bold text-info" style={{ fontSize: "30px" }}>Loading...</span></div>)
                                : 
                                <div className="collectionSite"><div className=" inner-heading">Collection Request Details</div>
                                    <Row className="px-4" style={{ fontSize: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <span><strong>Request ID</strong> | <strong>{this.state.selectedDispalyId}</strong></span>
                                        <span className="btn btn-secondary btn-custom tes-back" onClick={this.onClickBack}>Back</span>

                                    </Row>
                                    <Row className="px-4">
                                        <Col className="home-customer-options">
                                            <div className="home-customer-options-header">Equipment</div>
                                            <Col style= {{ height: '180px', overflowX: 'hidden'}}>
                                                {selectedProcessData && selectedProcessData.b2cCustomer ?
                                                    <Table bordered size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Asset</th>
                                                                <th>Brand</th>
                                                                <th>Quantity</th>
                                                                <th>Weight</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.props.assetsList && this.props.assetsList.length === 0 ?
                                                                    (<tr className="text-center"><td colSpan={6}>No Data</td></tr>)
                                                                    :
                                                                     this.props.assetsList && this.props.assetsList.map((item, index) => (
                                                                        <tr key={index} className="onHoverList">
                                                                            <td className="align-middle">{item.assetName}</td>
                                                                            <td className="align-middle">{item.manufacturer}</td>
                                                                            <td className="align-middle">{item.quantity}</td>
                                                                            <td className="align-middle">{item.weight}</td>
                                                                        </tr>
                                                                    ))
                                                            }
                                                        </tbody>
                                                    </Table> :
                                                    <div>
                                                        {selectedProcessData && selectedProcessData.assetType ?
                                                            <Fragment>
                                                                <Col className="pt-2">Asset: &nbsp;&nbsp;&nbsp; {(selectedProcessData && selectedProcessData.assetType) ? <strong style={{ marginLeft: '30px' }}>{selectedProcessData.assetType}</strong> : "--"}</Col>
                                                            </Fragment> : null
                                                        }
                                                        {selectedProcessData && selectedProcessData.brand ?
                                                            <Fragment>
                                                                <Col className="pt-2" >Brand: &nbsp;&nbsp;&nbsp;{(selectedProcessData && selectedProcessData.brand) ? <strong style={{ marginLeft: '30px' }}>{selectedProcessData.brand === 'Other' ? selectedProcessData.otherBrand : selectedProcessData.brand}</strong> : "--"}</Col>
                                                            </Fragment> : null
                                                        }
                                                        {
                                                            <Fragment>
                                                                <Col className="pt-2" >Quantity: &nbsp;&nbsp;&nbsp;<strong style={{ marginLeft: '13px' }}>1</strong></Col>
                                                            </Fragment>
                                                        }
                                                        {selectedProcessData && selectedProcessData.weight ?
                                                            <Fragment>
                                                                <Col className="pt-2">Weight: &nbsp;&nbsp;&nbsp;{(selectedProcessData && selectedProcessData.weight) ? <strong style={{ marginLeft: '23px' }}>{selectedProcessData.weight}</strong> : "--"}</Col>
                                                            </Fragment> : null
                                                        }
                                                    </div>
                                                }
                                            </Col>
                                        </Col>
                                        {
                                            (selectedProcessData && selectedProcessData.packingMaterialTrackingnumber) ?
                                                <Col className="home-customer-options">
                                                    <div className="home-customer-options-header">Packing Material</div>
                                                    <div>
                                                        {
                                                            <Fragment>
                                                                <Col className="pt-2">Package Type: &nbsp;&nbsp;&nbsp; {<strong style={{ marginLeft: '37px' }}>Box</strong>}</Col>
                                                            </Fragment>
                                                        }
                                                        {selectedProcessData && selectedProcessData.packingDate ?
                                                            <Fragment>
                                                                <Col className="pt-2">Package Dispatched: &nbsp;&nbsp;&nbsp;{(selectedProcessData && selectedProcessData.packingDate) ? <strong >{moment(parseInt(selectedProcessData.packingDate)).format(this.state.dateFormatByUser)}</strong> : "--"}</Col>
                                                            </Fragment> : null
                                                        }
                                                        {selectedProcessData && selectedProcessData.packingMaterialTrackingnumber ?
                                                            <Fragment>
                                                                <Col className="pt-2">Tracking No: &nbsp;&nbsp;&nbsp;{(selectedProcessData && selectedProcessData.packingMaterialTrackingnumber) ? <strong >{selectedProcessData.packingMaterialTrackingnumber}</strong> : "--"}</Col>
                                                            </Fragment> : null
                                                        }
                                                        {
                                                            <Fragment>
                                                                <Col className="pt-2">Carrier: &nbsp;&nbsp;&nbsp;<strong style={{ marginLeft: '13px' }}>{(selectedProcessData && selectedProcessData.carrierName) ? <strong style={{ marginLeft: '70px' }}>{selectedProcessData.carrierName}</strong> : "--"}</strong></Col>
                                                            </Fragment>
                                                        }
                                                        {selectedProcessData && selectedProcessData.packingMaterialTrackingnumber ?
                                                            <Fragment>
                                                                <Col className="pt-2" >Label: &nbsp;&nbsp;&nbsp;{(selectedProcessData && selectedProcessData.packingMaterialTrackingnumber) ? <strong style={{ marginLeft: '92px' }}><FontAwesomeIcon className={(!selectedProcessData.packingMaterialTrackingnumber || !selectedProcessData.carrierName) ? 'disableUps' : ''} onClick={() => this.printRequestLabel(selectedProcessData, 'label', 'packing')} style={{ marginRight: '8px', cursor: 'pointer', color: '#252f3e' }} icon={faDownload} /></strong> : "--"}</Col>
                                                            </Fragment> : null
                                                        }
                                                        {selectedProcessData && selectedProcessData.packingMaterialTrackingnumber ?
                                                            <Fragment>
                                                                <Col className="pt-2" >Invoice: &nbsp;&nbsp;&nbsp;{(selectedProcessData && selectedProcessData.packingMaterialTrackingnumber) ? <strong style={{ marginLeft: '82px' }}><FontAwesomeIcon className={(!selectedProcessData.packingMaterialTrackingnumber || !selectedProcessData.carrierName) ? 'disableUps' : ''} onClick={() => this.printRequestLabel(selectedProcessData, 'invoice', 'packing')} style={{ marginRight: '8px', cursor: 'pointer', color: '#252f3e' }} icon={faDownload} /></strong> : "--"}</Col>
                                                            </Fragment> : null
                                                        }
                                                    </div>
                                                </Col> : null
                                        }
                                        {(selectedProcessData && selectedProcessData.carrierTrackingnumber) ?
                                            <Col className="home-customer-options">
                                                <div className="home-customer-options-header">Pickup</div>
                                                <div>
                                                    {selectedProcessData && selectedProcessData.brand ?
                                                        <Fragment>
                                                            <Col className="pt-2">Collection Date: &nbsp;&nbsp;&nbsp;{(selectedProcessData && selectedProcessData.scheduleConfirmDate) ? <strong style={{ marginLeft: '28px' }} >{moment(parseInt(selectedProcessData.scheduleConfirmDate)).format(this.state.dateFormatByUser)}</strong> : <strong style={{ marginLeft: '28px' }} >{moment(parseInt(selectedProcessData.collectiondate)).format(this.state.dateFormatByUser)}</strong>}</Col>
                                                        </Fragment> : null
                                                    }
                                                    {
                                                        <Fragment>
                                                            <Col className="pt-2">Carrier: &nbsp;&nbsp;&nbsp;{(selectedProcessData && selectedProcessData.CarrierDetailId) ? <strong style={{ marginLeft: '82px' }}>{selectedProcessData.carrierInfo && selectedProcessData.carrierInfo.name}</strong> : <strong>{selectedProcessData.carrierName}</strong>}</Col>
                                                        </Fragment>
                                                    }
                                                    {selectedProcessData && selectedProcessData.carrierTrackingnumber ?
                                                        <Fragment>
                                                            <Col className="pt-2">Tracking No: &nbsp;&nbsp;&nbsp;{(selectedProcessData && selectedProcessData.carrierTrackingnumber) ? <strong style={{ marginLeft: '50px' }} >{selectedProcessData.carrierTrackingnumber}</strong> : "--"}</Col>
                                         
                                                            <Col className="pt-2">Label: &nbsp;&nbsp;&nbsp;{(selectedProcessData && selectedProcessData.carrierTrackingnumber) ? <strong style={{ marginLeft: '92px' }}><FontAwesomeIcon className={(!selectedProcessData.carrierTrackingnumber || !selectedProcessData.carrierName) ? 'disableUps' : ''} onClick={() => this.printRequestLabel(selectedProcessData, 'label', 'pickup')} style={{ marginRight: '8px', cursor: 'pointer', color: '#252f3e' }} icon={faDownload} /></strong> : "--"}</Col>
                                                 
                                                            <Col className="pt-2">Invoice: &nbsp;&nbsp;&nbsp;{(selectedProcessData && selectedProcessData.carrierTrackingnumber) ? <strong style={{ marginLeft: '82px' }}><FontAwesomeIcon className={(!selectedProcessData.carrierTrackingnumber || !selectedProcessData.carrierName) ? 'disableUps' : ''} onClick={() => this.printRequestLabel(selectedProcessData, 'invoice', 'pickup')} style={{ marginRight: '8px', cursor: 'pointer', color: '#252f3e' }} icon={faDownload} /></strong> : "--"}</Col>
                                                 
                                                            <Col className="pt-2">Package Instruction: &nbsp;&nbsp;&nbsp;{(selectedProcessData && selectedProcessData.carrierTrackingnumber) ? <strong style={{ marginLeft: '5px' }}><FontAwesomeIcon className={(!selectedProcessData.carrierTrackingnumber || !selectedProcessData.carrierName) ? 'disableUps' : ''} onClick={() => this.printRequestLabel(selectedProcessData, 'package', 'pickup')} style={{ marginRight: '8px', cursor: 'pointer', color: '#252f3e' }} icon={faDownload} /></strong> : "--"}</Col>
                                                        </Fragment> : null
                                                    }
                                                </div>
                                            </Col> : null
                                        }
                                    </Row>
                                </div>
                            }
                        </Card>
                    </div>
                </CSSTransitionGroup>
            </Fragment>
        )
    }
}


export default connect(mapStateToProps, mapActionsToProps)(Reports);
